// Homepage Composition (example)
import React, { useState, useEffect } from 'react';
import Layout from '../components/Modular/Layout';
import Section from '../components/Modular/Section';
import Unit from '../components/Modular/Unit';
import MicroUnit from '../components/Modular/MicroUnit';
import { Card } from '../components/Card';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import AuthFlow from '../components/Auth/AuthFlow';
import DropDown from '../components/DropDown/DropDown';
import { useWindowSize } from '../hooks/useWindowSize';
import { useAuth } from '../contexts/AuthProvider/AuthProvider';
import Dashboard from '../components/Dashboard/Dashboard';
import LoadingSpinner from '../components/LoadingSpinner';
import ServiceOffering from '../components/ServiceOffering/ServiceOffering';
import { AthenaCore } from 'athena-core';
import Title from '../components/Title/Title';
import Nav from '../components/Nav/Nav';

export const HomePage = () => {
  const windowSize = useWindowSize();
  // button layout switches to dropdown grid on mobile
  const buttonLayout = windowSize.width <= 798 ? 'grid' : 'flex';
  const responsiveTitle = windowSize.width <= 798 ? 'center' : 'left';
  const responsiveWidth = windowSize.width <= 798 ? '3' : '9';
  console.log(windowSize.width);

  const [navDropDown, setNavDropDown] = useState(false);
  const { user, loading, login, logout, isAuthenticated } = useAuth();

  const toggleNavMobile = () => {
    setNavDropDown((prev) => !prev);
  };

  const context = {
    section: {
      layout: 'grid',
      background: '',
      justifyItems: 'center',
      gap: 'md',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
      justifyContent: 'center',
    },
  };

  return (
    <Layout
      layout="grid"
      gap="md"
      background="brand-secondary"
      alignContent="center"
      justifyContent="center"
      context={context}
    >
      <Section
        layout="grid"
        gap="md"
        paddingLeft="lg"
        paddingRight="lg"
        paddingTop="sm"
        paddingBottom="sm"
      >
        <Title responsiveTitle={responsiveTitle}></Title>
        <Section
          justifyContent="left"
          width={windowSize.width >= 798 ? '7' : '3'}
        >
          {!isAuthenticated && <AuthFlow />}
          {user && <Dashboard user={user} />}
        </Section>

        <Section
          layout={buttonLayout}
          gridTemplate={`${buttonLayout === 'grid' ? 'vertical-4' : ''}`}
          gap="sm"
          justifyItems="center"
          justifyContent="center"
          width={responsiveWidth}
        >
          {windowSize.width >= 798 && <Nav></Nav>}

          {windowSize.width <= 798 && (
            <DropDown
              navDropDown={navDropDown}
              toggleNavMobile={toggleNavMobile}
            ></DropDown>
          )}
        </Section>
      </Section>

      {/*
              Animation here
              */}
      {loading && <LoadingSpinner></LoadingSpinner>}

      {/* <p>
              This site is a showcase of modular design, built for speed and
              clarity.
            </p> */}
    </Layout>
  );
};
